import { render, staticRenderFns } from "./GroupMembersUpload.vue?vue&type=template&id=3bb86489"
import script from "./GroupMembersUpload.vue?vue&type=script&lang=js"
export * from "./GroupMembersUpload.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersUpload.vue?vue&type=style&index=0&id=3bb86489&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports